import React from 'react';
import AppRoutes from './routes/AppRoutes';
import { ToastContainer, Flip } from "react-toastify";
import Loader from './components/loader/Loader';
import { IKContext } from 'imagekitio-react';

const IMAGEKIT_ID = process.env.REACT_APP_IMAGEKIT_ID;
const IMAGEKIT_PUBLIC_KEY = process.env.REACT_APP_IMAGEKIT_PUBLIC_KEY;
const IMAGEKIT_URL_ENDPOINT = `https://ik.imagekit.io/${IMAGEKIT_ID}`;

const App = () => {
  return (
    <div>
      <IKContext
        publicKey={IMAGEKIT_PUBLIC_KEY}
        urlEndpoint={IMAGEKIT_URL_ENDPOINT}
        transformationPosition="path"
        authenticationEndpoint="">

        <ToastContainer
          theme="light"
          position="top-right"
          transition={Flip}
          autoClose={5000}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover={false}
        />
        <Loader />
        <AppRoutes />
      </IKContext>
    </div>
  )
}

export default App